var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M11.75 21.75h-6.5V17c0-.965.785-1.75 1.75-1.75h3c.965 0 1.75.785 1.75 1.75zm-5-1.5h3.5V17a.25.25 0 0 0-.25-.25H7a.25.25 0 0 0-.25.25z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M20.084 9.791 14.75 7.505V4.309c0-.55-.251-1.057-.688-1.391a1.734 1.734 0 0 0-1.521-.297L4.277 4.874a2.756 2.756 0 0 0-2.026 2.653v11.472a2.752 2.752 0 0 0 2.75 2.75h14a2.752 2.752 0 0 0 2.75-2.75v-6.681a2.75 2.75 0 0 0-1.666-2.528zM13.25 20.25H5c-.689 0-1.25-.561-1.25-1.25V7.528c0-.562.379-1.058.921-1.206l8.265-2.253a.248.248 0 0 1 .215.042.245.245 0 0 1 .099.199v15.941zm7-1.25c0 .689-.561 1.25-1.25 1.25h-4.25V9.137l4.742 2.033c.46.197.758.648.758 1.149zm-9.5-10a.75.75 0 0 1-.75.75H7a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75zm0 3a.75.75 0 0 1-.75.75H7a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75zm8 5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 .75.75zm0-3a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 .75.75z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.b1699404d86968faefbdcb342d3d0fde.svg";
export { ForwardRef as ReactComponent };